module.exports = __webpack_public_path__ + "static/media/trash-2.7ccb43bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ai/icons/trash-2.svg
// module id = 3792
// module chunks = 0